/**
 * What: Typed schemas and contracts for server-driven semantic enrichment,
 *   metafield auto-classification, and category taxonomy normalization.
 * Transport / data-flow: Shared contracts between Shopify Worker LLM compilation routes,
 *   D1 storage, and client-facing Product Explorer read models.
 *
 */
import * as z from 'zod';
export const metafieldSemanticRoleSchema = z.enum([
    'claim',
    'brand_tagline',
    'taste_sensory',
    'offer',
    'price',
    'image',
    'packaging',
    'instructions',
    'advertising',
    'ingredient',
    'description',
    'target_audience',
    'usage_routine',
    'social_proof',
    'technical_spec',
    'unusable_internal',
]);
export const metafieldEnrichmentItemSchema = z.object({
    namespace: z.string(),
    key: z.string(),
    suggestedRole: metafieldSemanticRoleSchema,
    label: z.string(),
    reasoning: z.string().optional(),
    confidence: z.number().min(0).max(1).default(1),
});
export const metafieldEnrichmentBatchResponseSchema = z.object({
    items: z.array(metafieldEnrichmentItemSchema),
});
export const retailBroadVerticalSchema = z.enum([
    'beauty_skincare',
    'apparel',
    'food_beverage',
    'electronics',
    'home',
    'other',
]);
export const categoryTaxonomyItemSchema = z.object({
    rawProductType: z.string(),
    standardCategory: z.string(),
    broadVertical: retailBroadVerticalSchema,
    isBespokeOrSeasonal: z.boolean().default(false),
});
export const categoryTaxonomyBatchResponseSchema = z.object({
    items: z.array(categoryTaxonomyItemSchema),
});
export const claimArchetypeEnumSchema = z.enum([
    'efficacy',
    'ingredient',
    'sustainability',
    'sensory_routine',
    'general_claim',
]);
export const unstructuredClaimItemSchema = z.object({
    text: z.string(),
    archetype: claimArchetypeEnumSchema,
    confidence: z.number().min(0).max(1),
});
export const unstructuredClaimExtractionSchema = z.object({
    claims: z.array(unstructuredClaimItemSchema),
});
//# sourceMappingURL=product-semantic-enrichment.js.map